import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { status, restaurantId, customerId, riderId, startDate, endDate } =
      payload || {}

    return buildApiUrl(ADMIN_ENDPOINTS.ORDERS_LIST, {
      queryParams: {
        limit: 2000,
        status,
        restaurantId,
        customerId,
        riderId,
        startDate,
        endDate,
      },
    })
  },

  parse(raw = {}, payload = {}) {
    console.log(
      '🔍 ~ parse ~ v3/rapidoo-dashboard-v3/src/project/data/fetches/orders.js:27 ~ payload:',
      payload,
    )
    console.log('🚀 ~ raw:', raw)
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to fetch orders',
        data: null,
      }
    }

    // Nouveau format API V3
    const ordersData = raw.data?.data || []
    const pagination = raw.data || {}

    // 1. Mapping pour correspondre aux attentes du Dashboard Rapidoo
    const formattedOrders = ordersData.map(order => {
      // Extraction des items depuis la commande si disponibles
      const products =
        order.items?.map(item => ({
          id: item.dishId,
          name: item.title,
          quantity: item.quantity,
          unitPrice: item.unitPrice,
          totalPrice: item.totalPrice,
          notes: '',
        })) || []

      // Extraction des informations du livreur si disponibles
      const riderInfo =
        order.rider || order.delivery?.rider || order.assignedRider || {}
      const delivery = order.delivery || {}
      const riderId =
        order.riderId ||
        order.delivery?.riderId ||
        riderInfo.id ||
        riderInfo._id ||
        null
      const riderName =
        riderInfo.name ||
        riderInfo.fullName ||
        (riderInfo.firstName
          ? `${riderInfo.firstName} ${riderInfo.lastName || ''}`.trim()
          : '') ||
        order.riderName ||
        ''
      const riderPhoneNumber =
        riderInfo.phone || riderInfo.phoneNumber || order.riderPhoneNumber || ''
      const riderVehicle =
        riderInfo.vehicle || riderInfo.vehicleType || order.riderVehicle || '-'
      const riderAvatar =
        riderInfo.avatar || riderInfo.photoUrl || order.riderAvatar || null

      // Création de la timeline à partir du tableau timeline de l'API
      const timeline =
        order.timeline?.map(step => ({
          status: step.status,
          timestamp: step.timestamp,
          metadata: step.metadata || {},
        })) || []

      const stepsTimeline = (order.timeline || []).reduce((acc, step) => {
        if (step.status && step.timestamp) {
          acc[step.status] = step.timestamp
        }
        return acc
      }, {})

      // Fallbacks standard pour le stepper
      if (!stepsTimeline.created && order.createdAt)
        stepsTimeline.created = order.createdAt
      if (!stepsTimeline.payment && order.payment?.paidAt)
        stepsTimeline.payment = order.payment.paidAt
      if (!stepsTimeline.payment && order.payment?.status === 'paid')
        stepsTimeline.payment = order.createdAt
      if (!stepsTimeline.confirmed && (order.acceptedAt || order.confirmedAt))
        stepsTimeline.confirmed = order.acceptedAt || order.confirmedAt
      if (!stepsTimeline.assigned && (order.assignedAt || delivery.assignedAt))
        stepsTimeline.assigned = order.assignedAt || delivery.assignedAt
      if (!stepsTimeline.picked_up && (order.pickedUpAt || delivery.pickedUpAt))
        stepsTimeline.picked_up = order.pickedUpAt || delivery.pickedUpAt
      if (
        !stepsTimeline.delivered &&
        (order.deliveredAt || delivery.deliveredAt)
      )
        stepsTimeline.delivered = order.deliveredAt || delivery.deliveredAt

      return {
        id: String(order.id || ''),
        reference: String(order.reference || ''),
        deliveryCode: String(order.deliveryCode || ''),
        customerId: order.userId,
        customerName: String(
          order.summary?.customerName ||
            order.deliveryLocation?.contactName ||
            'Client Inconnu',
        ),
        customerPhoneNumber: String(order.deliveryLocation?.contactPhone || ''),
        customerAvatar: order.summary?.productImage || null,

        storeName: String(order.restaurantName || 'Restaurant Inconnu'),
        storeId: order.restaurantId,
        pickupAddress: order.restaurantName || '',
        pickupLat: null,
        pickupLng: null,

        // Informations du livreur
        riderId: riderId ? String(riderId) : null,
        riderName: String(riderName || ''),
        riderPhoneNumber: String(riderPhoneNumber),
        riderVehicle,
        riderAvatar,
        rider: {
          id: riderId ? String(riderId) : null,
          name: riderName,
          phone: riderPhoneNumber,
          vehicle: riderVehicle,
          avatar: riderAvatar,
          lat:
            delivery.currentLocation?.latitude || delivery.currentLocation?.lat,
          lng:
            delivery.currentLocation?.longitude ||
            delivery.currentLocation?.lng,
        },

        // Produits et notes
        products: products,
        drinks: [],
        customerNote: '',

        // Prix et paiement
        totalPrice: order.pricing?.total || 0,
        status: order.status,
        orderDate: order.createdAt,
        updatedAt: order.updatedAt,

        // Adresse de livraison
        destinationAddress: String(order.deliveryLocation?.address || ''),
        destinationLat: order.deliveryLocation?.lat,
        destinationLng: order.deliveryLocation?.lng,
        destinationCity: String(order.deliveryLocation?.city || ''),
        destinationDescription: String(
          order.deliveryLocation?.description || '',
        ),

        // Statut de livraison
        deliveryStatus: order.status,
        deliveryAssignedAt: order.assignedAt || delivery.assignedAt || null,
        deliveryEstimatedArrival: delivery.estimatedArrival || null,
        deliveryId: delivery.id || null,

        riderCommission: 0,

        // Prix détaillés
        pricing: order.pricing || {},
        deliveryFee: order.pricing?.deliveryFee || 0,
        serviceFee: order.pricing?.serviceFee || 0,
        subtotal: order.pricing?.subtotal || 0,
        discount: order.pricing?.discount || 0,

        // Paiement
        paymentMethod: String(order.payment?.method || ''),
        processor: order.payment?.method || 'Inconnue',
        isPaid: order.payment?.status === 'paid',
        paymentId: String(order.payment?.paymentId || ''),

        // Informations supplémentaires
        distanceKm: order.distanceKm || 0,
        durationMin: order.durationMin || 0,
        deliveryOption: order.deliveryOption || '',
        lockExpiresAt: order.lockExpiresAt || null,
        cancelledBy: order.cancelledBy || '',

        // Avis client
        rating: order.review?.rating || 0,
        reviewComment: order.review?.comment || '',
        reviewCreatedAt: order.review?.createdAt || '',
        reviewUpdatedAt: order.review?.updatedAt || '',

        // Timeline
        stepsTimeline: stepsTimeline,
        timeline: timeline,
      }
    })

    // 2. Application des filtres locaux
    let filtered = formattedOrders

    const searchTerm = (payload?.search || '').toString().trim().toLowerCase()
    if (searchTerm) {
      filtered = filtered.filter(o => {
        return (
          o.id.toLowerCase().includes(searchTerm) ||
          o.reference.toLowerCase().includes(searchTerm) ||
          o.deliveryCode.toLowerCase().includes(searchTerm) ||
          o.customerName.toLowerCase().includes(searchTerm) ||
          o.customerPhoneNumber.toLowerCase().includes(searchTerm) ||
          o.storeName.toLowerCase().includes(searchTerm) ||
          o.riderName.toLowerCase().includes(searchTerm) ||
          o.destinationAddress.toLowerCase().includes(searchTerm) ||
          o.paymentMethod.toLowerCase().includes(searchTerm)
        )
      })
    }

    // === Tri dynamique selon payload.sortKey et sortOrder ===
    let finalData = filtered
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      finalData = [...finalData].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]
        if (typeof valA === 'string' && typeof valB === 'string')
          return valA.localeCompare(valB) * order
        if (typeof valA === 'number' && typeof valB === 'number')
          return (valA - valB) * order
        return 0
      })
    }

    // === Pagination locale ===
    const { page = 0, limit = 20 } = payload || {}
    const paginated = finalData.slice(page * limit, (page + 1) * limit)

    // 3. Retour des données filtrées et mise à jour dynamique du total
    console.log(
      '🔍 ~ parse ~ v3/rapidoo-dashboard-v3/src/project/data/fetches/orders.js:234 ~ result:',
      formattedOrders,
    )
    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: searchTerm
          ? filtered.length
          : pagination.total || formattedOrders.length,
        result: paginated,
      },
    }
  },
}
